import * as types from '../constants/ActionTypes';

export const initialState = {
    exercisesInCart: [],
    homeworkTitle: '',
    homeworkDescription: '',
    message: '',
    loaded: true,
    inputError: false,
    deleteModalOpen: false,
    homeworkSaved: false,
    isSaving: false
};

export default function cart(state = initialState, action = {}) {
    const { type } = action;
    switch (type) {
        case types.ADD_EXERCISES_TO_CART: {
            const { exercisesToAdd } = action;
            exercisesToAdd.forEach(exercise => {
                if (!state.exercisesInCart.find(item => item.id === exercise.id)) {
                    state.exercisesInCart.push(exercise);
                }
            });
            return {
                ...state,
                exercisesInCart: state.exercisesInCart
            };
        }
        case types.ADD_EXERCISE_TO_CART: {
            const { exerciseAddedToCart } = action;
            if (!state.exercisesInCart.find(item => item.id === exerciseAddedToCart.id)) {
                return {
                    ...state,
                    exercisesInCart: state.exercisesInCart.concat(exerciseAddedToCart)
                };
            }
            return state;
        }
        case types.REMOVE_EXERCISE_FROM_CART: {
            const { exerciseIdRemovedFromCart } = action;
            return {
                ...state,
                exercisesInCart: state.exercisesInCart.filter(item => item.id !== exerciseIdRemovedFromCart)
            };
        }
        case types.CHANGE_HOMEWORK_TITLE:
            return {
                ...state,
                homeworkTitle: action.homeworkTitle,
                inputError: false
            };
        case types.CHANGE_HOMEWORK_DESCRIPTION: {
            return {
                ...state,
                homeworkDescription: action.homeworkDescription
            };
        }
        case types.CHANGE_INPUT_STYLE: {
            return {
                ...state,
                inputError: true
            };
        }
        case types.EMPTY_CART: {
            return {
                ...state,
                deleteModalOpen: false,
                exercisesInCart: [],
                homeworkTitle: '',
                homeworkDescription: '',
                inputError: false
            };
        }
        case types.CLOSE_EMPTY_CART_MODAL: {
            return {
                ...state,
                deleteModalOpen: false
            };
        }
        case types.OPEN_EMPTY_CART_MODAL: {
            return {
                ...state,
                deleteModalOpen: true
            };
        }
        case types.SAVE_HOMEWORK:
            return {
                ...state,
                homeworkSaved: false,
                isSaving: true
            };
        case types.SAVE_HOMEWORK_SUCCESS: {
            return {
                ...state,
                exercisesInCart: [],
                homeworkTitle: '',
                homeworkDescription: '',
                isSaving: false
            };
        }
        case types.SAVE_HOMEWORK_FAILURE: {
            return {
                ...state,
                homeworkSaved: false,
                isSaving: false
            };
        }
        case types.REORDER_EXERCISES: {
            return {
                ...state,
                exercisesInCart: action.exercises.map(item => ({
                    ...item,
                    isPreviewOpen: false
                }))
            };
        }
        default:
            return state;
    }
}
